var map = {
	"./desktop/previewdocument": "./framework/src/config/systemViews/desktop/previewdocument.json",
	"./desktop/previewdocument.json": "./framework/src/config/systemViews/desktop/previewdocument.json",
	"./phone/previewdocument": "./framework/src/config/systemViews/phone/previewdocument.json",
	"./phone/previewdocument.json": "./framework/src/config/systemViews/phone/previewdocument.json",
	"./tablet/previewdocument": "./framework/src/config/systemViews/tablet/previewdocument.json",
	"./tablet/previewdocument.json": "./framework/src/config/systemViews/tablet/previewdocument.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./framework/src/config/systemViews sync recursive ^\\.\\/.*$";